"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnEscapeHoC_1 = require("./OnEscapeHoC");
exports.default = OnEscapeHoC_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/behaviors/OnEscapeHoC/index.js
// module id = 1839
// module chunks = 8